import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadIcon } from 'assets/icons';
import { UserLoopModalContainer } from 'pages/AIMusicGenerator/components/Sidebar/components/UserLoop/components/UserLoopModalContainer';
import { UploadLoopData } from 'pages/AIMusicGenerator/components/Sidebar/components/UserLoopModal';
import UserLoopSelectorContainer from 'pages/Remixer/components/UserLoopSelectorContainer/UserLoopSelectorContainer';
import { DEFAULT_ENTROPY } from 'pages/Remixer/constants';
import useAnalytics from 'services/hooks/analytics/useAnalytics';
import useUrlLocation from 'services/hooks/urlLocation/useUrlLocation';
import { events } from 'services/analytics';
import { useAuthProtectedAction } from 'services/hooks/user';
import { UserLoop } from 'types';
import { StyledContainer, StyledGlassBox, StyledTypography } from './styled';

const UserLoopBox = () => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const location = useUrlLocation();

  const [userLoop, setUserLoop] = useState<UserLoop>();
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [isSelectDialogOpen, setIsSelectDialogOpen] = useState(false);

  const openUploadDialog = useCallback(() => {
    track(events.audioUploadClick(location));
    setIsUploadDialogOpen(true);
  }, [location, track]);

  const protectedOpenUploadDialog = useAuthProtectedAction(openUploadDialog);
  const closeUploadDialog = () => setIsUploadDialogOpen(false);

  const openSelectDialog = () => setIsSelectDialogOpen(true);
  const closeSelectDialog = () => setIsSelectDialogOpen(false);

  const handleUserLoopUpload = ({
    id: loopId,
    file,
    instrument,
  }: UploadLoopData) => {
    setUserLoop({
      loopId,
      loopFileName: file.name,
      entropy: DEFAULT_ENTROPY,
      instrument,
    });
    openSelectDialog();
  };

  return (
    <>
      <StyledContainer onClick={protectedOpenUploadDialog}>
        <StyledGlassBox>
          <UploadIcon />
          <StyledTypography>
            {t('remixer:userLoop:uploadAudioClip')}
          </StyledTypography>
        </StyledGlassBox>
      </StyledContainer>

      {userLoop && (
        <UserLoopSelectorContainer
          isOpen={isSelectDialogOpen}
          onClose={closeSelectDialog}
          data={userLoop}
        />
      )}
      <UserLoopModalContainer
        open={isUploadDialogOpen}
        onClose={closeUploadDialog}
        onUpload={handleUserLoopUpload}
      />
    </>
  );
};

export default UserLoopBox;
